var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compressor"},[_c('input',{attrs:{"type":"file","multiple":"multiple"},on:{"change":function($event){return _vm.createFilesUpload()}}}),_vm._l((_vm.images),function(image,index){return _c('img',{key:index,staticClass:"prev",attrs:{"src":`${image}`,"alt":""}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }